import React from 'react';

import { ImageProps } from './Image.interface';
import { useStyles } from './Image.styles';

function Image({
  alt,
  className,
  src,
  srcSet,
  srcSetWebp,
  onError,
  height,
  width,
}: ImageProps) {
  const classes = useStyles();

  return (
    <picture className={classes.root}>
      {srcSetWebp && <source srcSet={srcSetWebp} type="image/webp" />}
      {srcSet && <source srcSet={srcSet} />}
      <img
        src={src}
        alt={alt}
        className={className}
        onError={onError}
        height={height}
        width={width}
        loading="lazy"
      />
    </picture>
  );
}

export default React.memo(Image);
